/* eslint-disable ember/no-computed-properties-in-native-classes */
import Model, {
  attr,
  belongsTo,
  hasMany,
  type AsyncBelongsTo,
  type AsyncHasMany,
} from '@warp-drive/legacy/model';
import { computed } from '@ember/object';
import { alias } from '@ember/object/computed';
import type { Type } from '@warp-drive/core/types/symbols';
import type { FragmentArray } from 'ember-data-model-fragments/array/fragment';
import { fragmentArray } from 'ember-data-model-fragments/attributes';
import type Group from '@linc-technologies/linced-common/models/group';
import type Person from '@linc-technologies/linced-common/models/person';
import type Member from '@linc-technologies/linced-common/models/posts/member';
import type Page from '@linc-technologies/linced-common/models/posts/page';
import type School from '@linc-technologies/linced-common/models/school';
import { resolved } from '@linc-technologies/linced-common/utils/arrays';

// Proto: posts.PageSet.
export default class PageSet extends Model {
  declare [Type]: 'posts/page-set';

  @belongsTo('school', { async: true, inverse: null })
  declare schoolId: AsyncBelongsTo<School>;

  @alias('schoolId')
  declare school: AsyncBelongsTo<School>;

  @attr('string', { defaultValue: '' })
  declare campusId: string; // TODO: implement when we have Campuses

  @attr('number')
  declare createTime: number | undefined;

  @attr('number')
  declare updateTime: number | undefined;

  @belongsTo('person', { async: true, inverse: null })
  declare authorId: AsyncBelongsTo<Person>;

  @attr('string', { defaultValue: '' })
  declare label: string;

  @belongsTo('group', { async: true, inverse: null })
  declare autogroupId: AsyncBelongsTo<Group>;

  @alias('autogroupId')
  declare autogroup: AsyncBelongsTo<Group>;

  @fragmentArray('posts/member')
  declare learners: FragmentArray<Member>;

  // Pairs with posts/page.pageSetIds. linced-admin replaces posts/page with a
  // model that has no `pageSetIds`, so it overrides this relationship with
  // inverse: null -- see linced-admin/app/models/posts/page-set.js.
  @hasMany('posts/page', { async: true, inverse: 'pageSetIds' })
  declare pages: AsyncHasMany<Page>;

  // pages resolves to the loaded records rather than exposing the
  // PromiseManyArray itself: touching that promise's array-like surface
  // directly (e.g. a template {{#each}}/{{sort-by}}, or .filter()/.map())
  // is deprecated.
  @computed('pages.content.[]')
  get pagesArray() {
    return resolved(this.pages);
  }
}
